import React from 'react';
import ReactTable, { SortingRule, Filter, Resize, RowInfo } from 'react-table';
import { Column } from 'react-virtualized';
import { OrderDirection } from '@api/graphql/types';
import { ListOptionType } from '@reducers/listReducer';
import { ApplicationState } from 'reducers/';
import { connect, DispatchProp } from 'react-redux';
import { updateListOptions } from '@actions/listActions';

export type DirectionType = 'asc' | 'desc';

export interface OptionType {
    sortBy: {
        field: string,
        direction: OrderDirection.ASC | OrderDirection.DESC,
    };
    count: number;
    page: number;
    filters: {
        [key: string]: string | null,
    };
}

interface PropType {
    listName: string;
    defaultOptions: ListOptionType;
    columns: any;
    options: ListOptionType;
    data: any[];
    paginatorInfo: any;
    onOptionsChange?: (options: any) => void;
    onRowClick?: (finalState: any, rowInfo?: RowInfo, column?: Column, instance?: any) => object | undefined;
}

interface ReduxProps {
    listOptions: ListOptionType;
}

interface StateType {
    data: any[];
    paginatorInfo: any;
    loading: boolean;
}


class ControlledTable extends React.Component<PropType & ReduxProps & DispatchProp, StateType> {

    public state = {
        loading: false,
        data: [],
        paginatorInfo: {},
    };

    public componentWillReceiveProps(nextProps: PropType) {
        if (this.props.data !== nextProps.data) {
            this.setState({loading: false});
        }
    }

    private updateOptions = (options: any) => {
        this.setState({loading: true}, () => {
            if (this.props.onOptionsChange) {
                this.props.onOptionsChange(options);
            }

            if (this.props.listName) {
                this.props.dispatch(updateListOptions(this.props.listName, options));
            }
        });
    }

    private onPageChange = (page: number) => {
        const newOptions = {
            ...this.props.options,
            page,
        };
        this.updateOptions(newOptions);
    }

    private onPageSizeChange = (newPageSize: number, newPage: number) => {
        const newOptions = {
            ...this.props.options,
            count: newPageSize,
            page: newPage,
        };
        this.updateOptions(newOptions);
    }

    private onSortedChange = (newSorted: SortingRule[], column: string, shiftKey: boolean) => {
        const direction: OrderDirection = newSorted[0].desc ? OrderDirection.DESC : OrderDirection.ASC;
        const field = newSorted[0].id;
        const newOptions = {
            ...this.props.options,
            sortBy: {
                field,
                direction,
            },
        };
        this.updateOptions(newOptions);
    }

    private onExpandedChange = (column: any, event: any, isTouch: boolean) => {
        console.log({column, event, isTouch});
    }

    private onFilteredChange = (newFiltering: Filter[], column: any, value: any) => {
        console.log({newFiltering, column, value});
    }

    private onResizedChange = (newResized: Resize[], event: any) => {
        console.log({newResized, event});
    }

    private getSortByValue = (): SortingRule[] => {
        const { sortBy } = this.props.options;
        const returnedObject: SortingRule = { id: sortBy.field };

        if (sortBy.direction === OrderDirection.DESC) {
            returnedObject.desc = true;
        }

        return [returnedObject];
    }

    public render() {
        return (
            <ReactTable
                columns={this.props.columns}
                data={this.props.data}

                // Props
                page={this.props.options.page} // the index of the page you wish to display
                pages={this.props.paginatorInfo.lastPage}
                pageSize={this.props.options.count} // the number of rows per page to be displayed
                sorted={this.getSortByValue()}
                expanded={{}}
                filtered={[]}
                resized={[]}

                minRows={1}

                manual={true}

                className="-striped -highlight"

                loading={this.state.loading}

                // Callbacks
                onPageChange={this.onPageChange} // Called when the page index is changed by the user
                onPageSizeChange={this.onPageSizeChange} // Called when the pageSize is changed by the user. The resolve page is also sent to maintain approximate position in the data
                onSortedChange={this.onSortedChange} // Called when a sortable column header is clicked with the column itself and if the shiftkey was held. If the column is a pivoted column, `column` will be an array of columns
                onExpandedChange={this.onExpandedChange} // Called when an expander is clicked. Use this to manage `expanded`
                onFilteredChange={this.onFilteredChange} // Called when a user enters a value into a filter input field or the value passed to the onFiltersChange handler by the Filter option.
                onResizedChange={this.onResizedChange} // Called when a user clicks on a resizing component (the right edge of a column header)

                // on click
                getTdProps={(finalState: any, rowInfo?: RowInfo, column?: Column, instance?: any) => {
                    if (this.props.onRowClick) {
                        return this.props.onRowClick(finalState, rowInfo, column, instance);
                    }
                    return {};
                }}

            />
        );
    }
}


const mapStateToProps = ({ lists }: ApplicationState, props: PropType): ReduxProps => {
    return { listOptions: (lists ? (lists[props.listName] || props.defaultOptions) : props.defaultOptions) };
};

export default connect(mapStateToProps)(ControlledTable);



// WEBPACK FOOTER //
// ./src/components/ControlledTable.tsx